import React, { FC, useState } from 'react';
import classNames from 'classnames';
import { Textbox, TextBoxProps } from '../Textbox';
import Button from '../Button';
import { useControlFocusType } from '../../hooks/useControlFocusType';
import classes from './styles/index.module.scss';
import { Visibility } from '../Icons/Visibility';

export type PasswordTextBoxProps = TextBoxProps;

export const PasswordTextBox: FC<React.PropsWithChildren<PasswordTextBoxProps>> = (props) => {
	const componentClasses = classNames(classes.passwordTextBox, props.className);
	const [isPasswordVisible, setIsPasswordVisible] = useState(false);
	const { handleElementClick, handleElementFocus, handleElementBlur } = useControlFocusType();
	const buttonClasses = classNames(classes.passwordTextBoxBtn, {
		[classes.passwordTextBoxBtn_hidden]: !isPasswordVisible,
		[classes.passwordTextBoxBtn_visibility]: isPasswordVisible,
	});

	const togglePasswordVisibility = () => {
		setIsPasswordVisible(!isPasswordVisible);
	};

	const handleButtonClick = (e) => {
		handleElementClick(e);
		togglePasswordVisibility();
	};

	return (
		<div className={classes.passwordTextBox__wrapper}>
			<Textbox
				{...props}
				type={isPasswordVisible ? 'text' : 'password'}
				className={componentClasses}
				inputClassName={classes.passwordTextBox_input}
				placeholder='*****************'
			/>
			<Button
				type='button'
				startIcon={<Visibility />}
				className={buttonClasses}
				onFocus={handleElementFocus}
				onBlur={handleElementBlur}
				onClick={handleButtonClick}
				size='small'
				disabled={props.disabled}
			/>
		</div>
	);
};

PasswordTextBox.displayName = 'PasswordTextBox';
